//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () { return { list: [] } },
  created () {
    this.$ajax.get(this.$api.slRanking + '?contest_id=' + this.$route.query.id).then(r => {
      const arr = Array.isArray(r) ? r : (r && r.list) || []
      this.list = arr.slice().sort((a, b) => {
        const ra = a.teamRank || a.team_rank || 9999
        const rb = b.teamRank || b.team_rank || 9999
        return ra - rb
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/story-ladder/rank.vue